var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.dictionaryTypeName,"placement":_vm.tooltipPlacement,"disabled":_vm.tooltipDisabled,"open-delay":500}},[_c('v-icon',{attrs:{"color":_vm.dictionaryTypeColor,"small":_vm.small}},[_vm._v("icon-"+_vm._s(_vm.type)+"-dictionary")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }